import React, { useEffect } from "react";
import Timer from "../components/form-controls/Timer";

const BookingToast = ({
  enquiryId,
  bookingId,
  tripType,
  pickup,
  dropoff,
  drop,
  customer,
  message,
  id,
  history,
  travelDateTime,
  closeOnClick,
  closeToast,
  bookingType,
}) => {
  let tripTypeName;

  if (tripType === "bookRide") {
    tripTypeName = "Outstation";
  } else if (tripType === "local") {
    tripTypeName = "Local";
  } else if (tripType === "hourlyRental") {
    tripTypeName = "Hourly Rental";
  }

  const redirectToPage = (enquiryId) => {
    return enquiryId
      ? `/bookings/add/${id}?pusherEnq=${enquiryId}`
      : `/bookings/add/${id}`;
  };
  const redirectToB2BPage = () => {
    return `/booking/add/${id}`;
  };

  const handleButtonClick = () => {
    let destination;
    if (bookingType === "OTA") {
      destination = redirectToB2BPage();
    } else {
      destination = enquiryId ? redirectToPage(enquiryId) : redirectToPage("");
    }

    history.push(destination);
    if (closeOnClick) {
      closeToast(); // Close the toast if closeOnClick is true
    }
  };

  const formattedPhone =
    customer && `${customer.countryCode} - ${customer.phone}`;

  return (
    <div className="booking-toast">
      {bookingType === "OTA" ? (
        <div className="row">
          <p className="c-firstr">
            <strong>Reschedule</strong>
          </p>
        </div>
      ) : (
        ""
      )}
      {bookingId ? (
        <div className="row">
          <p className="c-first">
            <strong>Booking ID</strong>
          </p>
          <p>:</p>
          <p className="c-second">{bookingId}</p>
        </div>
      ) : (
        enquiryId && (
          <div className="row">
            <p className="c-first">
              <strong>Enquiry ID</strong>
            </p>
            <p>:</p>
            <p className="c-second">{enquiryId}</p>
          </div>
        )
      )}

      <div className="row">
        <p className="c-first">
          <strong>Triptype</strong>
        </p>
        <p>:</p>
        <p className="c-second">{tripTypeName}</p>
      </div>
      <div className="row">
        <p className="c-first">
          <strong>Pickup</strong>
        </p>
        <p>:</p>
        <p className="c-second">{pickup}</p>
      </div>
      {tripType === "hourlyRental" ? (
        ""
      ) : (
        <div className="row">
          <p className="c-first">
            <strong>Dropoff</strong>
          </p>
          <p>:</p>
          <p className="c-second">{dropoff || drop}</p>
        </div>
      )}

      {bookingType === "OTA" ? (
        <div className="row">
          <p className="c-first">
            <strong>Date & Time</strong>
          </p>
          <p>:</p>
          <p className="c-second">{travelDateTime}</p>
        </div>
      ) : (
        ""
      )}

      {enquiryId ? (
        <div className="row">
          <p className="c-first">
            <strong>Phone</strong>
          </p>
          <p>:</p>
          <p>{formattedPhone}</p>
        </div>
      ) : (
        customer && (
          <>
            <div className="row">
              <p className="c-first">
                <strong>Name</strong>
              </p>
              <p>:</p>
              <p>{customer.name}</p>
            </div>
            <div className="row">
              <p className="c-first">
                <strong>Phone</strong>
              </p>
              <p>:</p>
              <p className="c-second">{formattedPhone}</p>
            </div>
          </>
        )
      )}
      {bookingType === "OTA" ? (
        ""
      ) : (
        <div className="row">
          <p className="c-first">
            <strong>Message</strong>
          </p>
          <p>:</p>
          <p className="c-second">{message}</p>
        </div>
      )}

      <div className="redirect-button">
        <button onClick={handleButtonClick}>View Details</button>
      </div>

      {enquiryId && (
        <div className="timer-h">
          {/* Assuming Timer component exists and should be rendered */}
          <Timer />
        </div>
      )}
    </div>
  );
};

export default BookingToast;
